import classNames from 'classnames';

import styles from './CircleMark.module.css';

interface CircleMarkProps {
  checked?: boolean;
  disabled?: boolean;
  focused?: boolean;
  size?: 'md' | 'lg';
}
export function CircleMark(props: CircleMarkProps) {
  const className = classNames(styles.root, {
    [styles.checked]: props.checked,
    [styles.disabled]: props.disabled,
    [styles.md]: props.size === 'md',
    [styles.lg]: props.size === 'lg',
  });
  return <span aria-hidden className={className} />;
}
